import './styles.scss';

import { Col, Row } from 'react-bootstrap';

import Field from '@/common/Field';
import Modal from '@/common/Modal';
import { ReactElement } from 'react';
import SwitchInput from '@/common/SwitchInput';
import { titleCase } from '@/utils';
import { useVehiclesState } from '@/features/Vehicles';

type VehicleSettingsModalProps = {
  show: boolean;
  onHide: () => void;
};

const VehicleSettingsModal = ({ show, onHide }: VehicleSettingsModalProps): ReactElement => {
  const [{ settings, onSwitchColumn, onSwitchRememberFilters }] = useVehiclesState(({ state, setState }) => [
    {
      settings: state.settings,
      onSwitchColumn: (column: keyof typeof state.settings.columns) => () => {
        setState((current) => ({
          ...current,
          settings: {
            ...current.settings,
            columns: {
              ...current.settings.columns,
              [column]: !current.settings.columns[column],
            },
          },
        }));
      },
      onSwitchRememberFilters: () => {
        setState((current) => ({
          ...current,
          settings: {
            ...current.settings,
            rememberFilters: !current.settings.rememberFilters,
          },
        }));
      },
    },
  ]);

  return (
    <Modal className="VehicleSettingsModal" show={show} onHide={onHide} title="Vehicles Settings" centered>
      <Field label="Filters">
        <div className="VehicleSettingsModal-Filters">
          <Row>
            <Col md={4}>
              <SwitchInput
                type="switch"
                id="remember-filters"
                checked={settings.rememberFilters}
                onClick={onSwitchRememberFilters}
                label="Remember Filters"
              />
            </Col>
          </Row>
        </div>
      </Field>
      <Field label="Table Columns">
        <div className="VehicleSettingsModal-Columns">
          <Row>
            {Object.keys(settings.columns).map((col) => (
              <Col key={col} md={4}>
                <SwitchInput
                  type="switch"
                  id={`column-switch-${col}`}
                  checked={settings.columns[col as keyof typeof settings.columns]}
                  onClick={onSwitchColumn(col as keyof typeof settings.columns)}
                  label={titleCase(col.replace(/_/g, ' '))}
                />
              </Col>
            ))}
          </Row>
        </div>
      </Field>
    </Modal>
  );
};

export default VehicleSettingsModal;
